import React from 'react'
import intl from 'react-intl-universal'
import { Ellipsis, Button } from 'antd-mobile'
import AutoImage from '../AutoImage'
import CalendarIcon from '../Icon/CalendarIcon'
import dayjs from 'dayjs'

import defImg from '../../assets/images/def_img_food.png'

export default function PopupProducts({ list = [], cls = '', style = {}, from = 'merchant', showPMDetail }) {
    const formatTime = (time) => {
        return dayjs(time).format('YYYY-MM-DD')
    }
    return (
        <div className='pm-wrapper'>
            <ul className={`pd-list ${cls}`} style={style}>
                {
                    list.map((item, index) => {
                        let img = defImg
                        if (item.imageArray.length > 0) {
                            img = item.imageArray[0]
                        }
                        return <li className='pd-item jm-flex' key={index} onClick={e => showPMDetail(item)}>
                            <div className='pd-img-wrapper'>
                                <AutoImage
                                    src={img}
                                    alt="product"
                                    size='b' />
                            </div>

                            <div className='pd-content text-center' style={{ width: '100%' }}>
                                <div className='pd-name'><b>{item.activityTitle}</b></div>
                                <div className='p10'>
                                    <Button color='primary'  size='small'>
                                        {intl.get('lookDetail').d('查看详情')}
                                    </Button>
                                </div>
                            </div>
                        </li>
                    })
                }
            </ul>
        </div>
    )
}
